// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ebcb220a","455":"4bca1d01","977":"9d5c6597"}[chunkId] + ".chunk.js";
};